<template functional>
    <div class="comp-kind-chip chip chip-secondary text-uppercase d-inline-flex align-items-center gap-2">
        <b-icon :icon="props.kind.icon" variant="primary" class=""></b-icon>
        <span class="font-size-70">{{ props.kind.label }}</span>
    </div>
</template>

<script>
export default {
    functional: true,
    name: 'CompKindChip',
    components: {},
    mixins: [],
    props: {
        kind: {
            type: Object,
            required: true,
        },
    }
}
</script>

<style lang="scss">
.comp-kind-chip.chip {
    border: 1px solid var(--gray-300);
}
</style>